module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/folk-instruments-c0b666f1629b0d7fdccd240f9372ae11.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/folk-instruments.png
// module id = 1UGk
// module chunks = 12 16 18